import React, { useCallback, useEffect, useState } from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { useSelector } from "react-redux";

import { amazonHost } from "../../../paths";

import { Section, Ribbon } from "./styles";
import messages from "./messages";

const dev = process.env.NODE_ENV === "development";

const Creators = () => {
    const [rotate, setRotate] = useState<number | null>(null);
    const [loaded, setLoaded] = useState(false);
    const resize = useCallback(() => {
        if (window.innerWidth < 768) {
            let deg = (Math.sin(60 / window.innerWidth) * 180) / Math.PI;
            setRotate(deg);
        } else {
            setRotate(null);
        }
    }, [setRotate]);

    useEffect(() => {
        window.addEventListener("resize", resize);
        setTimeout(resize, 100);
        setLoaded(true);
        return () => {
            window.removeEventListener("resize", resize);
        }
    }, []);
    const webp = useSelector(({ webp }: any) => webp);
    return (
        <Section>
            <Ribbon className={"Ribbon1"}>
                <div className={"RibbonWrapper"}>
                    <div className={"Container"}>
                        <h3>
                            <FormattedMessage {...messages.a1_h3} />
                        </h3>
                        <p>
                            <FormattedHTMLMessage {...messages.a1_d} />
                        </p>
                    </div>
                    <img
                        src={
                            dev
                                ? `/local/bali-dani.${webp ? "webp" : "png"}`
                                : amazonHost + `landing/bali-dani.${webp ? "webp" : "png"}`
                        }
                        alt="Bali Daniel"
                    ></img>
                </div>
                {loaded && (
                    <>
                        <div className={"UpperRibbon"}></div>
                        <div className={"LowerShadow"} style={{ transform: rotate ? `rotate(${rotate}deg)` : "" }}></div>
                    </>
                )}
            </Ribbon>
            <Ribbon className={"Ribbon2"}>
                <div className={"RibbonWrapper"}>
                    <div className={"Container"}>
                        <h3>
                            <FormattedMessage {...messages.a2_h3} />
                        </h3>
                        <p>
                            <FormattedHTMLMessage {...messages.a2_d} />
                        </p>
                    </div>
                    <img
                        src={dev ? "/local/molnar-dani.jpg" : amazonHost + "landing/molnar-dani.jpg"}
                        alt="Molnár Daniel"
                    ></img>
                </div>
                {loaded && (
                    <>
                        <div className={"UpperRibbon"}></div>
                        <div className={"LowerShadow"} style={{ transform: rotate ? `rotate(${-rotate}deg)` : "" }}></div>
                    </>
                )}
            </Ribbon>
            <Ribbon className={"Ribbon3"}>
                <div className={"RibbonWrapper"}>
                    <div className={"Container"}>
                        <h3>
                            <FormattedMessage {...messages.a3_h3} />
                        </h3>
                        <p>
                            <FormattedHTMLMessage {...messages.a3_d} />
                        </p>
                    </div>
                    <img
                        src={
                            // dev
                            //     ? `/local/bali-dani.${webp ? "webp" : "png"}`
                                amazonHost + `landing/albert.webp`
                        }
                        alt="Albert Tay"
                    ></img>
                </div>
                {loaded && (
                    <>
                        <div className={"UpperRibbon"}></div>
                        <div className={"LowerShadow"} style={{ transform: rotate ? `rotate(${rotate}deg)` : "" }}></div>
                    </>
                )}
            </Ribbon>
            <Ribbon className={"Ribbon4"}>
                <div className={"RibbonWrapper"}>
                    <div className={"Container"}>
                        <h3>
                            <FormattedMessage {...messages.a4_h3} />
                        </h3>
                        <p>
                            <FormattedHTMLMessage {...messages.a4_d} />
                        </p>
                    </div>
                    <img
                        src={amazonHost + "landing/mich.webp"}
                        alt="Mich Tay Yi Xuan"
                    ></img>
                </div>
                {loaded && (
                    <>
                        <div className={"UpperRibbon"}></div>
                        <div className={"LowerShadow"} style={{ transform: rotate ? `rotate(${-rotate}deg)` : "" }}></div>
                    </>
                )}
            </Ribbon>
            <Ribbon className={"Ribbon5"}>
                {loaded && (
                    <>
                        <div className={"UpperRibbon"}></div>
                    </>
                )}
            </Ribbon>
        </Section>
    );
}

export default Creators;
